<!-- PROVIDER_REQUESTS_REFUND_INVOICES -->

<template>
  <div :class="['ms-form', 'ms-form--narrow', { purpose: this.data?.body?.purpose }]">
    <q-form @submit="this.onSubmit">
      <div class="ms-form-grid ms-form-grid--single">
        <!-- Agreement cancel type selection -->
        <div class="radio_btns">
          <div>
            <q-radio v-model="formData.invoice_type" :val="1" label="Без удержания" />
          </div>
          <div>
            <q-radio v-model="formData.invoice_type" :val="2" label="Штраф" />
          </div>
        </div>
        <!-- Показываем поле для penalty_sum, если выбран вариант 2 -->
        <div v-if="formData.invoice_type === 1">
          <CustomSelect :options="warehouseOptions" label="Склад" :required="true" optionValueKey="warehouse_id"
            optionLabelKey="warehouse_name" :fullWidth="true" :value="this.formData.warehouse_id"
            @change="(value) => onChange('warehouse_id', value)" />
        </div>
      </div>
      <CustomModalFooter :btn-loading="this.btnLoading" />
    </q-form>
  </div>
</template>

<script>
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomSelect from "@/components/form/CustomSelect";
import { getWarehouses } from "@/views/ProviderRequests/services";

export default {
  name: "prov-req-refund-invoices",
  components: { CustomModalFooter, CustomSelect },
  props: ['data'],
  data() {
    return {
      loading: false,
      btnLoading: false,
      formData: {
        provider_request_id: this.data?.providerRequestId || '',
        invoice_type: '',
        warehouse_id: '',
        provider_request_invoice_item_id_arr: this.data?.body?.data
          ? this.data.body.data.map(item => item.provider_request_item_id)
          : '',
      },
      warehouseOptions: [],
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value;
    },
    async onSubmit() {
      this.btnLoading = true

      if (this.formData.invoice_type === 2) {
        delete this.formData.warehouse_id;
      }
      await this.data?.onSubmit(this.formData)
      this.btnLoading = false
    },
    async fetchWarehouses() {
      this.warehouseOptions = await getWarehouses();
    },
  },
  mounted() {
    this.fetchWarehouses();
  }
}
</script>

<style scoped lang="scss">
// Сетка — общая (ms-form-* в theme.scss)
.radio_btns {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 20px;
  margin-left: -8px;
}
</style>